import React from "react";
import { Bar, Pie, Radar } from "react-chartjs-2";

import students from "./data/students.json";
import teachers from "./data/teachers.json";

/* ===================== HELPERS ===================== */

function average(arr) {
  if (!arr || arr.length === 0) return 0;
  var sum = 0;
  for (var i = 0; i < arr.length; i++) {
    sum += arr[i];
  }
  return sum / arr.length;
}

/* ===================== KPI CARD ===================== */

function KpiCard(props) {
  return (
    <div style={{
      padding: 16,
      borderRadius: 6,
      background: "#fff",
      boxShadow: "0 1px 4px rgba(0,0,0,0.1)"
    }}>
      <h4 style={{ margin: 0, color: "#666" }}>{props.title}</h4>
      <h2 style={{ margin: "8px 0 0" }}>{props.value}</h2>
    </div>
  );
}

/* ===================== DASHBOARD ===================== */

function DashboardReportV2() {

  /* ===== KPIs ===== */
  var totalStudents = students.length;
  var totalTeachers = teachers.length;

  var avgPassRate = average(
    teachers.map(function (t) { return t.passRate; })
  ).toFixed(1);

  var avgAttendance = average(
    teachers.map(function (t) { return t.attendance; })
  ).toFixed(1);

  /* ===== Students by Class ===== */
  var classMap = {};
  students.forEach(function (s) {
    if (!classMap[s.class]) classMap[s.class] = 0;
    classMap[s.class]++;
  });

  var classLabels = Object.keys(classMap);
  var classCounts = classLabels.map(function (k) {
    return classMap[k];
  });

  /* ===== Category Distribution ===== */
  var categoryMap = {};
  students.forEach(function (s) {
    categoryMap[s.category] = (categoryMap[s.category] || 0) + 1;
  });

  var categoryLabels = Object.keys(categoryMap);
  var categoryCounts = categoryLabels.map(function (k) {
    return categoryMap[k];
  });

  /* ===== Teacher Performance Radar ===== */
  var teacherLabels = teachers.slice(0, 6).map(function (t) {
    return t.name;
  });

  var teacherScores = teachers.slice(0, 6).map(function (t) {
    return (
      t.passRate * 0.4 +
      t.avgMarks * 0.3 +
      t.attendance * 0.2 +
      t.evaluation * 10 * 0.1
    ).toFixed(1);
  });

  /* ===================== CHART DATA ===================== */

  var studentByClassData = {
    labels: classLabels,
    datasets: [
      {
        label: "Students",
        backgroundColor: "#4f46e5",
        data: classCounts
      }
    ]
  };

  var categoryPieData = {
    labels: categoryLabels,
    datasets: [
      {
        backgroundColor: [
          "#2563eb",
          "#16a34a",
          "#dc2626",
          "#ca8a04",
          "#9333ea"
        ],
        data: categoryCounts
      }
    ]
  };

  var teacherRadarData = {
    labels: teacherLabels,
    datasets: [
      {
        label: "Performance Score",
        backgroundColor: "rgba(37,99,235,0.2)",
        borderColor: "#2563eb",
        pointBackgroundColor: "#2563eb",
        data: teacherScores
      }
    ]
  };

  /* ===================== UI ===================== */

  return (
    <div style={{ padding: 24, background: "#f4f6f8" }}>

      {/* KPI SECTION */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: 16,
        marginBottom: 24
      }}>
        <KpiCard title="Total Students" value={totalStudents} />
        <KpiCard title="Total Teachers" value={totalTeachers} />
        <KpiCard title="Avg Pass Rate (%)" value={avgPassRate} />
        <KpiCard title="Avg Attendance (%)" value={avgAttendance} />
      </div>

      {/* CHARTS */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "2fr 1fr",
        gap: 24
      }}>
        <div style={{ background: "#fff", padding: 16 }}>
          <h3>Students by Class</h3>
          <Bar data={studentByClassData} />
        </div>

        <div style={{ background: "#fff", padding: 16 }}>
          <h3>Student Categories</h3>
          <Pie data={categoryPieData} />
        </div>
      </div>

      {/* <div style={{ marginTop: 24, background: "#fff", padding: 16 }}>
        <h3>Teacher Performance (Top 6)</h3>
        <Radar data={teacherRadarData} />
      </div> */}

    </div>
  );
}

export default DashboardReportV2;
